const wrapper = document.querySelector('.wrapper');
const mobileNav = document.querySelector('.js-nav');
const mobileNavBtn = Array.from(document.querySelectorAll('.js-btn-nav'));

mobileNavBtn.map(btn => {
	btn.addEventListener('click', function(event) {
		event.preventDefault();

		this.closest('.nav-secondary').querySelector('.js-nav').classList.toggle('is-open');
		wrapper.classList.toggle('is-open');
	});
});